import { dataShortVideo } from 'dls-icons-data'
import { createIcon } from '../common'

const IconShortVideo = /*#__PURE__*/createIcon(dataShortVideo)
export default IconShortVideo
